import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Switch,
  Typography,
} from "@material-ui/core";
import KasriBoreshDialog from "./components/KasriBoreshDialog";
import FixerLastikDialog from "./components/FixerLastikDialog";
import ProfileSetting from "./components/ProfileSetting";
import DeleteDasteProfile from "./components/DeleteDasteProfile";
import FormControl from "@material-ui/core/FormControl";
import { disableDasteProfile, getAllDasteProfile, setNameForSearchProfileCategory } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { SELECTED_DASTE_PROFILE } from "Stores/actionTypes";
import Translator from "Languages/Utility/Translator";
import { ReactSVG } from "react-svg";
import checkBoxCheckIcon from "Assets/svg/icon/checkBoxCheckIcon.svg";
import checkedBoxIcon from "Assets/svg/icon/checkedBoxIcon.svg";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Input from "Components/Input/Input";
import * as Icons from 'react-bootstrap-icons'
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import { useTheme } from '@material-ui/core/styles';

function DasteProfile() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { dasteProfileList, selectedDasteProfile, profileCategorySearch } = useSelector((state) => ({
    dasteProfileList: state.profile.dasteProfileList,
    selectedDasteProfile: state.profile.selectedDasteProfile,
    profileCategorySearch: state.profile.profileCategorySearch,
  }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(false);

  const handleChange = async (value) => {
    dispatch({
      type: SELECTED_DASTE_PROFILE,
      selectedDasteProfile: value,
    });
  }

  const setValue = (name, value) => {
    dispatch(setNameForSearchProfileCategory(value));
  };

  const onSearch = async (e) => {
    e.preventDefault();
    await onGetAllDasteProfile();
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    await onGetAllDasteProfile(true);
  }
  
  const switchChange = async (e, item) => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: Number(item.Id),
        Disable: !e.target.checked,
      };
      await dispatch(disableDasteProfile(data));
      await onGetAllDasteProfile();
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }

  const onGetAllDasteProfile = async (clear = false, selectedIndex = -1) => {
    try {
      setLoading(true);
      let dataSearch = null;
      if(!clear && profileCategorySearch && profileCategorySearch !== "") dataSearch = { Name: profileCategorySearch } 
      if(clear) dispatch(setNameForSearchProfileCategory(""));
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        ...dataSearch
      };
      await dispatch(getAllDasteProfile(params, selectedIndex));
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }
  
  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="side-box">
        <div>
          <MuiIconButton
            title={<Translator id={"searchProfileCategory"} />}
            icon={<Icons.Search size={17}/>}
            onClick={() => setSearch(!search)}
            className={`fix-size ${search ? "standby" : ''}`}
            disabled={!selectedDasteProfile}
          />
          <Translator id={"profileCategory"} />
        </div>
        <div>
          {
            selectedDasteProfile &&
            <>
              <FixerLastikDialog />
              {selectedDasteProfile.Struct === 1 && <KasriBoreshDialog />}
              <ProfileSetting reGetOnBack={onGetAllDasteProfile} />
              <DeleteDasteProfile reGetOnBack={onGetAllDasteProfile} />
            </>
          }
        </div>
      </div>
      <div className={`search-box-sidebox ${search ? 'show-mode' : 'hide-mode' }`}>
        <Input
          setValue={setValue.bind(this)}
          name="search"
          value={profileCategorySearch}
          placeholder={t('searchProfileCategory')}
          type="search"
          onSearch={onSearch}
          onClearSearch={onClearSearch}
        />
      </div>
      {dasteProfileList && selectedDasteProfile && (
        <FormControl component="fieldset" className="radioGroup sideBoxLg">
          <RadioGroup>
            {dasteProfileList.map((item) => {
              return (
                <div className="d-flex justify-content-between align-items-center my-2 g-2" key={item.Id}>
                  <FormControlLabel
                    value={item.Id}
                    key={item.Id}
                    className={ direction === 'rtl' ? "text-right" : "text-left" }
                    control={
                      <Radio
                        checked={selectedDasteProfile.Id === item.Id}
                        onChange={() => handleChange(item)}
                      />
                    }
                    label={item.Name}
                  />
                  <Switch
                    className={`switcher ${direction}`}
                    color="primary"
                    checked={!item.Disable}
                    disabled={item.IsG && read("StypeU") !== "1"}
                    onChange={(e) => switchChange(e, item)}
                  />
                </div>
              );
            })}
          </RadioGroup>
        </FormControl>
      )}
    </>
  );
}

export default DasteProfile;
